import { Box } from "@mui/material"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"
import React from "react"
import { clearDrawerData, editUserId, isValidatingUser, originalUserData, userErrorRegistry, userPayload } from "Pages/Admin/Users/@signals"
import useCreateUsersModal from "Pages/Admin/Users/@hooks/useCreateModal"
import { useComputed } from "@preact/signals-react"
import { computeDiff } from "Pages/Admin/Users/@utils/diff"

export default function UserCreateFooter() {

	const { onRequestSave, isEditLoading } = useCreateUsersModal()

	const hasChanges = useComputed(() => {
		if (!editUserId.value) return true
		return computeDiff(originalUserData.value, userPayload.value).length > 0
	})

	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-evenly", gap: 2 }}>
		<ButtonLoadingSeeker
			onClick={clearDrawerData}
			startIcon={<IconSeeker icon="xmark"/>}
		>
			Cancel
		</ButtonLoadingSeeker>
		<ButtonLoadingSeeker
			disabled={isEditLoading || !hasChanges.value || Object.values(userErrorRegistry.value)?.some(e => !e) || isValidatingUser.value}
			startIcon={<IconSeeker iconType="mui" icon="mdi:content-save-check"/>}
			onClick={onRequestSave}
			loading={isEditLoading}
		>
			Save
		</ButtonLoadingSeeker>
	</Box>
}